"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setGlobals = exports.getGlobals = void 0;
const getGlobals = () => {
  if (typeof window === 'undefined') {
    return global.___storeGlobalVars || {};
  }
  return window.___storeGlobalVars || {};
};
exports.getGlobals = getGlobals;
const setGlobals = data => {
  if (typeof window === 'undefined') {
    global.___storeGlobalVars = data;
  } else {
    window.___storeGlobalVars = data;
  }
};
exports.setGlobals = setGlobals;